export enum globalErrorActionTypes {
  SET_ERROR = 'globalError/setError',
}
